import { FC } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "../../../../hooks/useTranslate";

import { useDynamicThemeAwareVariables } from "@/features/FormV2/hooks/useDynamicThemeAwareVariables";
import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { Heart, Warning } from "@/icons/outlined";

export type BidStatus = "isOutbid" | "isWinning";

export interface ThemedBidBadgeProps {
  status: BidStatus;
}

export const ThemedBidBadge: FC<ThemedBidBadgeProps> = ({ status }) => {
  const { t } = useTranslate();

  const icon = {
    isOutbid: <Warning />,
    isWinning: <Heart />,
  }[status];

  const text = {
    isOutbid: t("ticketing", "yourOutbid"),
    isWinning: t("ticketing", "yourTopBidder"),
  }[status];

  const colors = useDynamicThemeAwareVariables(({ formsPalette, mode }) => ({
    backgroundColor: mode === "light" ? formsPalette.surface.quiet : formsPalette.surface.supershy,
    iconFill: formsPalette.text.brand,
  }));

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      paddingX={1}
      paddingY={0.5}
      borderRadius={1}
      width="fit-content"
      sx={{ backgroundColor: colors.backgroundColor }}
    >
      {/* Icon */}
      {icon && (
        <FormIcon size="small" color={colors.iconFill}>
          {icon}
        </FormIcon>
      )}

      {/* Text */}
      <FormTypography variant="subtitle2" vibe="brand">
        {text}
      </FormTypography>
    </Stack>
  );
};
